<template>
  <section class="the-time-of-loving-god-wrap" v-parallax v-slide-up-in>
    <v-page :background="theme.colors.cyan">
      <v-sub-chapter-index-page
        :pageData="pageDataItem.page0.data"
        v-slide-up-in-stage="1"
      />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-time-of-loving-God/page1ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page1.data"
        v-slide-up-in-stage="2"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page2.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-float-image-content :data="pageDataItem.page3.data.content" />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-text-content :html="pageDataItem.page4.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-time-of-loving-God/page4ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page5.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page6.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-text-content :html="pageDataItem.page7.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-time-of-loving-God/page8ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page8.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-time-of-loving-God/page7ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page9.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-time-of-loving-God/page9ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page10.data"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-text-content :html="pageDataItem.page11.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-time-of-loving-God/page10ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page12.data"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-full-screen-songs-player
        :data="pageDataItem.page13.data"
        bg="images/common/hymnsPosters/six-trials-of-God-s-judgment-work-3.jpg"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-chatper-entry bg-color="earth" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
    };
  },
  created() {
    this.pageDataItem = this.schema["the-time-of-loving-God"].item;
  },
};
</script>
